<template>
    <div>
        <h2>Kataloganfrage</h2>
        <p>Gerne senden wir Ihnen einen Katalog zu, schicken Sie dazu einfach das ausgefüllte Formular an uns:</p>
        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Katalog</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                <el-select style="width:100%;" v-model="form.Katalog" placeholder="Bitte wählen" name="Katalog" v-validate="'required'"><el-option v-for="item in optionsKatalog" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select>
            </el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Anrede</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"
                ><el-select style="width:100%;" v-model="form.Anrede" placeholder="Bitte wählen" name="Anrede" v-validate="'required'"><el-option v-for="item in optionsAnrede" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select
            ></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Vorname</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input placeholder="" v-model="form.Vorname" name="Vorname" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Name</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input placeholder="" v-model="form.Name" name="Name" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Straße</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input placeholder="" v-model="form.Straße" name="Straße" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">PLZ/Ort</div></el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="4"><el-input placeholder="" v-model="form.PLZ" name="PLZ" v-validate="'required'"></el-input></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">&nbsp;</el-col>
            <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="13"><el-input placeholder="" v-model="form.Ort" name="Ort" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">Telefon</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input placeholder="" v-model="form.Telefon"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div style="font-weight:bold">E-Mail</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input placeholder="" v-model.trim="form.EMail" name="E-Mail" v-validate="'unisigns-email'"></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="2"><el-checkbox v-model="checkedDatenschutz" name="Datenschutz" v-validate="'required:invalidateFalse'" color="#ff6600" class="kat-checkbox"></el-checkbox></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="22" >
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="22"><span style="font-weight:bold">Ja, ich habe die <a href="https://www.gessert-reisen.de/#/article/datenschutz">Datenschutzerklärung</a> gelesen und akzeptiere diese.</span></el-col>
            </el-col >
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="2"><el-checkbox v-model="checkedAGB" name="AGB" v-validate="'required:invalidateFalse'" class="kat-checkbox"></el-checkbox></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="22"
                ><span style="font-weight:bold">Ja, ich habe die <a href="https://www.gessert-reisen.de/#/article/agb">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.</span></el-col
            >
        </el-row>

        <el-button type="warning" @click="sendForm">Anfrage senden</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            optionsKatalog: [
                {
                    value: "Katalog Mehrtagesreisen",
                    label: "Katalog Mehrtagesreisen"
                },
                {
                    value: "Tagesfahrten",
                    label: "Tagesfahrten"
                }
            ],

            optionsAnrede: [
                {
                    value: "Herr",
                    label: "Herr"
                },
                {
                    value: "Frau",
                    label: "Frau"
                }
            ],
            form: {
                Formular: "Kataloganfrage",
                Katalog: "",
                Anrede: "",
                Vorname: "",
                Name: "",
                Straße: "",
                PLZ: "",
                Ort: "",
                EMail: "",
                Telefon: "",
            },
            checkedAGB: false,
            checkedDatenschutz: false
        }
    },
    methods: {
        sendForm() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$alert(this.errors.all().join("<br>"), "Fehler", { dangerouslyUseHTMLString: true })
                    return
                }

                let formData = new FormData()
                for (const key in this.form) {
                    formData.append(key, this.form[key])
                }

                // fetch("https://web.unisigns.de/customer/gessert/php/mail_action.php", { method: "POST", body: formData })
                fetch("php/mail_action.php", { method: "POST", body: formData })
                    .then(res => res.text())
                    .then(jsonData => {
                        this.form = {}
                        this.$alert("Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.", "Mail versendet", { dangerouslyUseHTMLString: true })
                    })
                    .catch(error => {
                        this.$alert("Die E-Mail konnte leider nicht versendet werden.", "Fehler", { dangerouslyUseHTMLString: true })
                        return
                    })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-row {
    padding: 10px 0px;
}

.us-form-label {
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
}
.el-button {
    width: 100%;
    background-color: #ee9301;
}
</style>

<style>
.el-checkbox.kat-checkbox .el-checkbox__inner { border: 2px solid #b90202 !important; }
.el-checkbox.kat-checkbox .el-checkbox__input.is-checked .el-checkbox__inner { border: 2px solid #b90202 !important; }
.el-checkbox.kat-checkbox .el-checkbox__inner::after { border-color:#fff !important; }
</style>
